// ignore-string-externalization
import { Type, ButtonPrimary, cssColorValue, spacer8, spacer12, spacer16, spacer20, spacer24, spacer32, spacer48, display1FontSizeXSmall, screenSmMax, screenXsMax, heading2FontSize, white } from '@spotify-internal/encore-web';
import styled, { css } from 'styled-components';
import { hexToRgba } from '@mrkt/features/color-conversion';
import { ImageAspectBox16x9, ButtonTertiaryAsLink, fadeInAnimation, UnstyledLink, withAnimationContext, DELAYS } from '../ui';
import { transformScaleUp } from '../utils';
export var Headline = withAnimationContext(styled(Type.h1).attrs({
  paddingBottom: '0.67em',
  variant: 'altoBrio',
  weight: 'bold'
}).withConfig({
  displayName: "indexstyles__Headline",
  componentId: "sc-13rax0b-0"
})(["", ";padding-top:", ";padding-bottom:", ";font-size:", ";max-width:684px;@media (max-width:", "){text-align:left;font-size:", ";padding-top:0;padding-bottom:", ";}"], fadeInAnimation(DELAYS.SECOND), spacer8, spacer8, display1FontSizeXSmall, screenSmMax, heading2FontSize, spacer8));
export var Subtext = withAnimationContext(styled(Type.p).attrs({
  variant: 'ballad'
}).withConfig({
  displayName: "indexstyles__Subtext",
  componentId: "sc-13rax0b-1"
})(["padding-top:0;", ";"], fadeInAnimation(DELAYS.THIRD)));
export var CTALink = styled(ButtonTertiaryAsLink).withConfig({
  displayName: "indexstyles__CTALink",
  componentId: "sc-13rax0b-2"
})(["padding-left:0;text-align:left;color:", ";svg{margin-left:", ";vertical-align:-2px;}&&:hover:not(:disabled),&:focus:not(:disabled),&:active:not(:disabled){color:", ";outline:none;}"], function (props) {
  var _props$theme$link;

  return (_props$theme$link = props.theme.link) === null || _props$theme$link === void 0 ? void 0 : _props$theme$link.color;
}, spacer8, function (props) {
  var _props$theme$link2;

  return hexToRgba((_props$theme$link2 = props.theme.link) === null || _props$theme$link2 === void 0 ? void 0 : _props$theme$link2.color, 0.5);
});
export var ItemList = styled.ul.withConfig({
  displayName: "indexstyles__ItemList",
  componentId: "sc-13rax0b-3"
})(["display:flex;flex-flow:row wrap;justify-content:flex-start;align-content:flex-start;width:100%;padding-left:0px;"]);
export var Item = styled.li.withConfig({
  displayName: "indexstyles__Item",
  componentId: "sc-13rax0b-4"
})(["margin:0 ", " ", " 0;list-style:none;width:", ";@media (max-width:", "){width:calc(50% - ", ");}@media (max-width:", "){width:100%;margin-bottom:", ";}"], spacer20, spacer48, function (props) {
  return props.featured ? "calc(50% - ".concat(spacer20, ")") : "calc(33.33% - ".concat(spacer20, ")");
}, screenSmMax, spacer20, screenXsMax, spacer32);
export var ImageWrapper = styled(ImageAspectBox16x9).withConfig({
  displayName: "indexstyles__ImageWrapper",
  componentId: "sc-13rax0b-5"
})(["overflow:hidden;", " svg{display:", ";position:absolute;bottom:", ";left:", ";width:", ";height:auto;color:", ";z-index:3;@media (max-width:", "){bottom:", ";left:", ";}@media (max-width:", "){bottom:", ";left:", ";}}&:hover{img,svg{", ";transition:transform 0.3s ease-in-out;}svg{opacity:0.8;}}"], function (props) {
  return props.video && css(["&::before{content:'';position:absolute;top:0;height:100%;width:100%;box-shadow:inset 0 -90px 10px 0 rgba(0,0,0,0.1);z-index:2;}"]);
}, function (props) {
  return props.video ? 'initial' : 'none';
}, function (props) {
  return props.featured ? spacer24 : spacer16;
}, function (props) {
  return props.featured ? spacer24 : spacer16;
}, function (props) {
  return props.featured ? '48px' : '32px';
}, cssColorValue('backgroundBase'), screenXsMax, spacer12, spacer12, screenSmMax, spacer16, spacer16, transformScaleUp);
export var ItemLabel = withAnimationContext(styled(Type.p).attrs({
  variant: 'finale',
  weight: 'book'
}).withConfig({
  displayName: "indexstyles__ItemLabel",
  componentId: "sc-13rax0b-6"
})(["", ";padding-top:", ";padding-bottom:0;text-transform:uppercase;color:", ";"], fadeInAnimation(DELAYS.FOURTH), spacer20, function (props) {
  return props.theme.label.color;
}));
export var ItemTitle = withAnimationContext(styled(Type.h3).attrs({
  variant: 'celloCanon',
  weight: 'bold'
}).withConfig({
  displayName: "indexstyles__ItemTitle",
  componentId: "sc-13rax0b-7"
})(["", ";padding-top:", ";padding-bottom:", ";max-height:3.6em;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;@media (max-width:", "){padding-top:", ";padding-bottom:0;}"], fadeInAnimation(DELAYS.FIFTH), spacer16, spacer8, screenSmMax, spacer8));
export var ItemText = withAnimationContext(styled(Type.p).attrs({
  variant: 'ballad'
}).withConfig({
  displayName: "indexstyles__ItemText",
  componentId: "sc-13rax0b-8"
})(["", ";@media (max-width:", "){display:none;}"], fadeInAnimation(DELAYS.SIXTH), screenXsMax));
export var StyledLink = styled(UnstyledLink).withConfig({
  displayName: "indexstyles__StyledLink",
  componentId: "sc-13rax0b-9"
})(["text-decoration:none;color:", ";&:hover,&:focus:not(:disabled),&:active:not(:disabled){text-decoration:none;color:", ";}&:hover{img,svg{", ";transition:transform 0.3s ease-in-out;}svg{opacity:0.8;}}"], function (props) {
  var _props$theme$link3;

  return ((_props$theme$link3 = props.theme.link) === null || _props$theme$link3 === void 0 ? void 0 : _props$theme$link3.color) || white;
}, function (props) {
  var _props$theme$link4;

  return hexToRgba(((_props$theme$link4 = props.theme.link) === null || _props$theme$link4 === void 0 ? void 0 : _props$theme$link4.color) || white, 0.5);
}, transformScaleUp);
export var LoadMoreButton = styled(ButtonPrimary).withConfig({
  displayName: "indexstyles__LoadMoreButton",
  componentId: "sc-13rax0b-10"
})([""]);
export var LoadMoreButtonWrapper = styled.div.withConfig({
  displayName: "indexstyles__LoadMoreButtonWrapper",
  componentId: "sc-13rax0b-11"
})(["text-align:center;width:100%;margin-bottom:", ";"], spacer20);